import React from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Label,
  Input
} from 'reactstrap';

export default props => {
  return (
    <Modal
      isOpen={props.isActive}
      toggle={props.toggle}
      className={props.className}
    >
      <ModalHeader toggle={props.toggle}>Filter</ModalHeader>
      <ModalBody className={'p-4'}>
        <FormGroup>
          <Label for="association-status">Association Status</Label>
          <Input
            type={'select'}
            name="status"
            id="association-status"
            disabled={props.loading}
            value={props.status}
            onChange={e =>
              props.onFilter({
                phraze: props.value,
                limit: props.limit,
                sort: props.sort,
                direction: props.direction,
                status: e.currentTarget.value,
                association_type_id: props.association_type_id
              })
            }
          >
            <option value={1}>Active</option>
            <option value={0}>Inactive</option>
          </Input>
        </FormGroup>
        <FormGroup>
          <Label for="association-type">Association Type</Label>
          <Input
            type={'select'}
            name="type"
            id="association-type"
            value={props.association_type_id}
            disabled={props.loading}
            onChange={e =>
              props.onFilter({
                phraze: props.value,
                limit: props.limit,
                sort: props.sort,
                direction: props.direction,
                status: props.status,
                association_type_id: e.currentTarget.value
              })
            }
          >
            <option value={'all'}>All</option>
            {Object.keys(props.associationTypes).map(index => {
              return (
                <option key={'association-type-' + index} value={index}>
                  {props.associationTypes[index]}
                </option>
              );
            })}
          </Input>
        </FormGroup>
      </ModalBody>
      <ModalFooter className={'py-4'}>
        <Button
          color="primary"
          className={'btn-sm px-3'}
          onClick={props.toggle}
        >
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};
